/* eslint-disable react/display-name */
import React from 'react';

import { Icon } from '@iwoca/orion';

import messages from './ManualCompanyAddressDE/ManualCompanyAddressDE.messages';
import commonMessages from '../Containers.messages';

export const DE_FULL_POSTCODE_LENGTH = 5;
const PostcodeFilter =
    ({ hasMoreResults, intl }) =>
    ({
        searchTerm,
        setNewSearchTerm,
        resetSelection,
        openSearchMenu,
        closeSearchMenu
    }) => {
        const showPostcodeFilter = hasMoreResults || searchTerm.postcode;

        if (!showPostcodeFilter) {
            return null;
        }

        const meetsMinimumSearchRequirements = (searchTerm) =>
            searchTerm.length === DE_FULL_POSTCODE_LENGTH;
        return (
            <div className="addon-wrapper right postcode-filter-container">
                <input
                    className="form-control postcode-filter"
                    value={searchTerm.postcode}
                    onClick={(e) => {
                        const postcodeInput = e.target;
                        postcodeInput.focus();
                        const moveCaretToEndOfInput = (position) =>
                            postcodeInput.setSelectionRange(position, position);
                        moveCaretToEndOfInput(postcodeInput.value.length);
                    }}
                    onKeyDown={(e) => {
                        // Stops enter key causing form errors showing by stopping form submit
                        if (e.which === 13) e.preventDefault();
                        resetSelection();
                    }}
                    onChange={(e) => {
                        if (e.target.value.length <= DE_FULL_POSTCODE_LENGTH) {
                            setNewSearchTerm(
                                { ...searchTerm, postcode: e.target.value },
                                {
                                    getNewOptions:
                                        meetsMinimumSearchRequirements(
                                            e.target.value
                                        )
                                }
                            );
                        }
                    }}
                    onFocus={openSearchMenu}
                    onBlur={closeSearchMenu}
                    autoComplete="off"
                    placeholder={`${intl.formatMessage(
                        messages.postcode
                    )} (${intl.formatMessage(commonMessages.optional)})`}
                />

                <span>
                    <Icon icon="filterFilled" />
                </span>
            </div>
        );
    };

export default PostcodeFilter;
